import React from 'react';
import Tooltip from '../Tooltip';
import { SettingSideBoxContext } from './index';
export default class ListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    iconfontCls = (fontName, another) => {
        return `icon iconfont icon-${fontName} ${another}`;
    };
    getListItem = (keyWord, item, params) => {
        let { label, required, noDeletion, redstar, showItem, highLight, islock, isLastLockCol, visible } = item;

        // 右侧已选 过滤掉移动到左侧的数据 visible = false
        if (!showItem && visible) {
            return <div
                className={`per-column ${!showItem && (highLight || islock) ? 'active-per-column' : ''} ${keyWord && label?.includes(keyWord) ? 'selectBykeyword' : ''}`}
            >
                {required && <span className="unselected-mark">*</span>}
                <span className="Column-label">{label}</span>
                {
                    !islock ?
                        <span className="column-icon" onClick={params.ToHideOneCol.bind(this, item)}>
                            <Tooltip
                                placement="top"
                                overlay={params.json['table_colseting_delete']}
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i
                                    className={this.iconfontCls('shenpibohui', 'moveToRight')}
                                    style={(noDeletion || redstar) ? { color: '#aeaeae', cursor: 'not-allowed' } : {}}
                                />
                            </Tooltip>
                        </span>
                        :
                        null
                }
                {/* <span className="column-icon" onClick={params.ToSetWidth.bind(this, item)}>
                    <Tooltip
                        placement="top"
                        overlay={params.json['table_col_setting_setWidth']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i
                            className={this.iconfontCls('liekuanshezhi', 'toLock')}
                        />
                    </Tooltip>
                </span> */}
                {highLight ?
                    <span className="column-icon column-icon-active" onClick={params.ToUnHighLightCols.bind(this, item)}>
                        <Tooltip
                            placement="top"
                            overlay={params.json['table_col_setting_reset_hightLight']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i className={this.iconfontCls('tgaoliang', 'close')} />
                        </Tooltip>
                    </span>
                    :
                    <span className="column-icon" onClick={params.ToHighLightCols.bind(this, item)}>
                        <Tooltip
                            placement="top"
                            overlay={params.json['table_col_setting_hightLight']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className={this.iconfontCls('gaoliang', 'close')}

                            />
                        </Tooltip>
                    </span>
                }
                {
                    isLastLockCol ?
                        <span className="column-icon column-icon-active" onClick={params.ToUnLockCols.bind(this, item)}>
                            <Tooltip
                                placement="top"
                                overlay={params.json['table_col_setting_unlock']}
                                delayHide={1}
                                delayShow={1000}
                            >
                                <i className={this.iconfontCls('suoding', 'close')} />
                            </Tooltip>
                        </span>
                        : (!islock ?
                            <span className="column-icon" onClick={params.ToLockCols.bind(this, item)}>
                                <Tooltip
                                    placement="top"
                                    overlay={params.json['table_col_setting_lock']}
                                    delayHide={1}
                                    delayShow={1000}
                                >
                                    <i className={this.iconfontCls('weisuoding', 'close')} />
                                </Tooltip>
                            </span>
                            : null
                        )
                }
            </div>;
        }

        // 左侧待选
        if (showItem) {
            return <div
                className={`per-column ${!showItem && (highLight || islock) ? 'active-per-column' : ''} ${keyWord && label?.includes(keyWord) ? 'selectBykeyword' : ''}`}
            >
                {required && <span className="unselected-mark">*</span>}
                <span className="Column-label">{label}</span>
                <span className="column-icon" onClick={params.chooseColumn.bind(this, item)}>
                    <Tooltip
                        placement="top"
                        overlay={params.json['table_col_setting_add']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={this.iconfontCls('ncc-sq', 'close')} />
                    </Tooltip>
                </span>
                <span className="column-icon" onClick={params.ToLockCols.bind(this, item)}>
                    <Tooltip
                        placement="top"
                        overlay={params.json['table_col_setting_lock']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={this.iconfontCls('suoding', 'close')} />
                    </Tooltip>
                </span>
                <span className="column-icon" onClick={params.ToHighLightCols.bind(this, item)}>
                    <Tooltip
                        placement="top"
                        overlay={params.json['table_col_setting_hightLight']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={this.iconfontCls('gaoliang', 'close')} />
                    </Tooltip>
                </span>
            </div>;
        }
    }
    render() {
        let { keyWord, item } = this.props;
        return (
            <SettingSideBoxContext.Consumer>
                {
                    params => this.getListItem(keyWord, item, params)
                }
            </SettingSideBoxContext.Consumer>
        );
    }
}